// @flow

import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import Radio from 'common/domain/radio';
import PrintingLogo from './PrintingLogo';
import { CentralMarket } from '../../../../statsradio/modules/centralMarkets/domain/CentralMarket';
import FeaturePermission from '../../../components/FeaturePermission';

export const PRINTING_HEADER_TITLE_ID = 'printingHeaderTitle';
export const PRINTING_HEADER_MARKET_ID = 'printingHeaderMarket';

const Wrapper = styled.div`
  width: 100%;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${({ theme }) => theme.metrics.smallMargin}px;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  margin-bottom: ${({ theme }) => theme.metrics.smallMargin}px;
`;

type Props = {
  radio: Radio,
  centralMarket: ?CentralMarket,
  theme: any,
  t: any,
}

export function PrintingHeader({ radio, centralMarket, theme, t }: Props) {
  return (
    <Wrapper>
      <PrintingLogo radio={radio} />
      <Header>
        <Title id={PRINTING_HEADER_TITLE_ID} style={{ ...theme.fonts.style.secondary, fontWeight: 'bold' }}>
          {radio.name.toUpperCase()} ({radio.callSign.toUpperCase()})
        </Title>
        <FeaturePermission feature="CENTRAL_MARKET_MODULE">
          <Title id={PRINTING_HEADER_MARKET_ID} style={{ ...theme.fonts.style.sub, fontWeight: 'bold' }}>
            {t('market')} : {centralMarket && centralMarket.name}{!centralMarket && t('fullMarket')}
          </Title>
        </FeaturePermission>
      </Header>
    </Wrapper>
  );
}


export default translate()(withTheme(PrintingHeader));



// WEBPACK FOOTER //
// ./src/common/modules/printing/components/PrintingHeader.js